export default "__VITE_ASSET__CQ3IFRLW__"